import type { InputHTMLAttributes } from 'react';
import styles from './SearchInput.module.css';

type SearchInputProps = InputHTMLAttributes<HTMLInputElement> & {
  wrapperClassName?: string;
};

export default function SearchInput({
  className = '',
  wrapperClassName = '',
  ...rest
}: SearchInputProps) {
  return (
    <div className={`${styles.wrapper} ${wrapperClassName}`.trim()}>
      <svg className={styles.icon} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clipRule="evenodd"
        />
      </svg>
      <input className={`${styles.input} ${className}`.trim()} {...rest} />
    </div>
  );
}
